import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import  { View } from 'react-native';

import MarketValueHeader from '../../../../components/common/market-value-header';

import styles from './asset-header.styles';

function AssetHeader({
  marketValue,
  dayChangeValue,
  dayChangePercent,
  currency,
  messages
}) {
  return (
    <View style={styles.container} testID="asset-header">
      <MarketValueHeader
        marketValue={marketValue}
        marketValueUnit={currency}
        dayChange={dayChangeValue}
        dayChangePercentage={dayChangePercent}
        dayChangeUnit={currency}
        messages={messages}
      />
    </View>
  );
}

AssetHeader.propTypes = {
  marketValue: PropTypes.number,
  dayChangeValue: PropTypes.number,
  dayChangePercent: PropTypes.number,
  currency: PropTypes.string,
};

export default pure(AssetHeader);
